document.addEventListener("DOMContentLoaded", () => {
  const selects = document.querySelectorAll("[data-filter-select]");

  selects.forEach(select => {
    // Toggle dropdown on click
    select.addEventListener("click", (e) => {
      const isOpen = select.classList.contains("open");
      selects.forEach(s => s.classList.remove("open"));
      if (!isOpen) {
        select.classList.add("open");
      }
    });

    // Close dropdown when clicking an option
    select.querySelectorAll("option").forEach(option => {
      option.addEventListener("click", (e) => {
        select.classList.remove("open");
      });
    });
  });

  // Close all dropdowns when clicking outside
  document.addEventListener("click", () => {
    selects.forEach(select => {
      select.classList.remove("open");
    });
  });
});

const openPopup = document.querySelector('[data-dealer-popup]');
const popupOverlay = document.querySelector('[data-popup-overlay="dealer"]');
const closePopup = document.querySelector('[data-action-close]');
const checkbox = document.querySelector('[data-dealer-popup-input-label]');

openPopup.addEventListener("click", () => {
  popupOverlay.style.display = "flex";
  popupOverlay.classList.add('popup-active');
});

closePopup.addEventListener("click", () => {
  popupOverlay.style.display = "none";
  popupOverlay.classList.remove('popup-active');
  document.querySelector('[data-dealer-popup-form]').classList.remove('contact-sponser-form--parent-active');
  document.querySelector('[data-dealer-popup-button]').classList.remove('contact-sponser-form__button--active');
  checkbox.checked = false;
});

popupOverlay.addEventListener("click", (e) => {
  if (e.target === popupOverlay) {
    popupOverlay.style.display = "none";
    popupOverlay.classList.remove('popup-active');
    document.querySelector('[data-dealer-popup-form]').classList.remove('contact-sponser-form--parent-active');
    document.querySelector('[data-dealer-popup-button]').classList.remove('contact-sponser-form__button--active');
    checkbox.checked = false;
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.querySelector('[data-dealer-popup-input-label]');
  const button = document.querySelector('[data-dealer-popup-button]');
  const parentDiv = document.querySelector('[data-dealer-popup-form]');

  checkbox.addEventListener('change', function () {
    if (checkbox.checked) {
      button.classList.add('contact-sponser-form__button--active');
    } else {
      button.classList.remove('contact-sponser-form__button--active');
    }
  });

  button.addEventListener('click', function () {
    parentDiv.classList.add('contact-sponser-form--parent-active');
  });

  let popupOverlaySuccess = document.querySelector('[data-popup-overlay-success]');
  let closeButtonSuccess = document.querySelector('[data-action-close-success]');
  let live_url = window.location.href;
  let result = live_url.includes('contact_posted=true');

  if (result && popupOverlay) {
    popupOverlaySuccess.style.display = "flex";
    popupOverlaySuccess.classList.add('popup-url-active');

    popupOverlaySuccess.addEventListener('click', function () {
      closePopupSuccess();
    });

    if (closeButtonSuccess) {
      closeButtonSuccess.addEventListener('click', function (event) {
        event.stopPropagation();
        closePopupSuccess();
      });
    }
  }
});

function closePopupSuccess() {
  let popupOverlaySuccess = document.querySelector('[data-popup-overlay-success]');
  if (popupOverlaySuccess) {
    popupOverlaySuccess.style.display = "none";
    popupOverlaySuccess.classList.remove('popup-url-active');
  }
  removeQueryParameter('contact_posted');
}

function removeQueryParameter(parameterName) {
  const urlParts = location.href.split('?');
  if (urlParts.length === 2) {
    const baseURL = urlParts[0];
    const queryString = urlParts[1];
    const queryParams = new URLSearchParams(queryString);
    if (queryParams.has(parameterName)) {
      queryParams.delete(parameterName);
      const newURL = queryParams.toString() ? `${baseURL}?${queryParams.toString()}` : baseURL;
      history.pushState(null, null, newURL);
    }
  }
}

const mainBuildProduct = document.querySelectorAll('[data-build-product]');
function initializeVehicleDropdown() {
  const vehicleSelect = document.querySelector("[data-product-brand]");
  const uniqueVehicles = new Set();
  mainBuildProduct.forEach(product => {
    const vehicleFilters = product.getAttribute("data-vehicle-filter").split(",");
    vehicleFilters.forEach(vehicle => uniqueVehicles.add(vehicle.trim()));
  });
  console.log(mainBuildProduct.length);
  const customOrder = [
    "PORSCHE",
    "BMW",
    "TOYOTA",
    "TESLA",
    "HONDA",
    "SUBARU",
    "FORD",
    "CHEVROLET",
    "HYUNDAI",
    "GENESIS",
    "KIA",
  ];
  const vehiclesArray = Array.from(uniqueVehicles);
  vehiclesArray.sort((a, b) => {
    const indexA = customOrder.indexOf(a);
    const indexB = customOrder.indexOf(b);
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return a.localeCompare(b);
  });
  vehiclesArray.forEach(vehicle => {
    if (vehicle !== "") {
      const option = document.createElement("option");
      option.value = vehicle;
      option.textContent = vehicle;
      vehicleSelect.appendChild(option);
    }
  });
}

function updateModelDropdown() {
  const vehicle = document.querySelector("[data-product-brand]").value;
  const modelSelect = document.querySelector("[data-product-model]");
  // const yearSelect = document.querySelector("[data-product-year]");
  modelSelect.innerHTML = '<option value="">Select model</option>';
  // yearSelect.innerHTML = '<option value="">Select Year</option>';
  modelSelect.disabled = true;
  // yearSelect.disabled = true;
  const uniqueModels = new Set();
  mainBuildProduct.forEach(product => {
    const vehicleFilters = product.getAttribute("data-vehicle-filter").split(",");
    if (vehicleFilters.includes(vehicle)) {
      const modelFilters = product.getAttribute("data-model-filter").split(",");
      modelFilters.forEach(model => uniqueModels.add(model.trim()));
    }
  });
  const sortedModels = Array.from(uniqueModels).sort();
  sortedModels.forEach(model => {
    const option = document.createElement("option");
    option.value = model;
    option.textContent = model;
    modelSelect.appendChild(option);
  });
  modelSelect.disabled = false;
}

// function updateYearDropdown() {
//   const vehicle = document.querySelector("[data-product-brand]").value;
//   const model = document.querySelector("[data-product-model]").value;
//   const yearSelect = document.querySelector("[data-product-year]");
//   yearSelect.innerHTML = '<option value="">Select Year</option>';
//   yearSelect.disabled = true;
//   const uniqueYears = new Set();
//   mainBuildProduct.forEach(product => {
//     const vehicleFilters = product.getAttribute("data-vehicle-filter").split(",");
//     const modelFilters = product.getAttribute("data-model-filter").split(",");
//     if (vehicleFilters.includes(vehicle) && modelFilters.includes(model)) {
//       const yearFilters = product.getAttribute("data-year-filter").split(",");
//       yearFilters.forEach(year => uniqueYears.add(year.trim()));
//     }
//   });
//   uniqueYears.forEach(year => {
//     const option = document.createElement("option");
//     option.value = year;
//     option.textContent = year;
//     yearSelect.appendChild(option);
//   });
//   yearSelect.disabled = false;
// }

document.addEventListener("DOMContentLoaded", initializeVehicleDropdown);

document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('[data-form-file-options] form');
  forms.forEach((form) => {
    const fileInput = form.querySelector('[data-contact-form-file]');
    const fileListContainer = form.querySelector('[data-contact-form-file-list]');
    const uploadButton = form.querySelector('[data-contact-form-submit-button]');
    const presignEndpointUrl = 'https://adro-api.lukuku.co/api/presigned-url';
    const s3DomainUrl = 'https://adro-assets.s3.amazonaws.com';

    let currentFiles = 0;
    let uploadedFiles = 0;
    let totalFilesToUpload = 0;
    let globalIndex = 0;

    if (!fileInput || !fileListContainer) return;

    fileInput.addEventListener('change', async function (event) {
      const files = Array.from(event.target.files);

      uploadedFiles = 0;
      totalFilesToUpload = files.length;

      if (currentFiles + files.length > 5) {
        alert('You can only upload a maximum of 5 files.');
        return;
      }

      updateUploadButtonState(true);

      files.forEach(async (file) => {
        if (file.size > 10 * 1024 * 1024) {
          alert(`${file.name} exceeds the 10MB size limit.`);
          return;
        }

        const fileItem = document.createElement('div');
        fileItem.className = 'file-item';
        fileItem.style.display = 'none';
        fileItem.innerHTML = `
                      <span>${file.name} 
                          <span class="file-size">${(file.size / 1024 / 1024).toFixed(2)}</span> 
                          <span class="file-size-unit">MB</span>
                      </span>
                      <button class="file-remove-btn" data-contact-form-file-remove-button>X</button>`;
        fileListContainer.appendChild(fileItem);

        const removeBtn = fileItem.querySelector('[data-contact-form-file-remove-button]');
        removeBtn.addEventListener('click', () => {
          fileItem.remove();
          const hiddenInput = form.querySelector(`[data-file-index="${fileItem.dataset.index}"]`);
          if (hiddenInput) hiddenInput.remove();
          currentFiles--;
          updateUploadButtonState();
        });

        try {
          const response = await fetch(presignEndpointUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name: file.name }),
          });

          const { uploadUrl, uploadPath } = await response.json();
          const uploadResponse = await fetch(uploadUrl, {
            method: 'PUT',
            body: file,
            headers: {
              'Content-Type': file.type,
            },
          });

          if (uploadResponse.ok) {
            const fileUrl = `${s3DomainUrl}/${uploadPath}`;
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = `contact[upload_file_${globalIndex + 1}]`;
            hiddenInput.value = fileUrl;
            hiddenInput.dataset.fileIndex = globalIndex;
            fileItem.dataset.index = globalIndex;
            form.appendChild(hiddenInput);

            fileItem.style.display = 'flex';
            const uploadedInfo = document.createElement('span');
            uploadedInfo.textContent = ' - Uploaded';
            fileItem.querySelector('span').appendChild(uploadedInfo);

            currentFiles++;
            uploadedFiles++;
            globalIndex++;
          } else {
            fileItem.querySelector('span').textContent = `${file.name} (Upload Failed)`;
          }
        } catch (error) {
          fileItem.querySelector('span').textContent = `${file.name} (Upload Failed)`;
        } finally {
          if (uploadedFiles === totalFilesToUpload) {
            updateUploadButtonState(false);
          }
        }
      });
    });

    function updateUploadButtonState(isUploading = false) {
      if (isUploading) {
        uploadButton.classList.add('contact__button-uploading');
      } else {
        uploadButton.classList.remove('contact__button-uploading');
      }
    }
  });
});

document.querySelectorAll('[data-contact-form-file-button]').forEach(button => {
  button.addEventListener('click', function () {
    const form = this.closest('form');
    if (form) {
      const fileInput = form.querySelector('[data-contact-form-file]');
      if (fileInput) {
        fileInput.click();
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const requiredForms = document.querySelectorAll('[data-form-required-fields] form');
  requiredForms.forEach(form => {
    const submitButton = form.querySelector('button[type="submit"]');
    const errorMessage = form.querySelector('[data-contact-form-error-message]');
    const fileList = form.querySelector('[data-contact-form-file-list]');

    function checkRequiredFields() {
      const requiredFields = form.querySelectorAll('[data-required]');
      let allFilled = true;

      requiredFields.forEach(field => {
        if (field.type === 'file') {
          if (field.files.length === 0 && !hasFileItem()) {
            allFilled = false;
          }
        } else if (!field.value.trim() && !field.selectedIndex) {
          allFilled = false;
        }
      });

      if (!allFilled) {
        errorMessage.style.display = 'block';
        submitButton.setAttribute('disabled', 'disabled');
      } else {
        errorMessage.style.display = 'none';
        submitButton.removeAttribute('disabled');
      }
    }

    function hasFileItem() {
      const fileItems = fileList.querySelectorAll('.file-item');
      return fileItems.length > 0;
    }

    form.addEventListener('input', checkRequiredFields);
    form.addEventListener('change', checkRequiredFields);

    form.addEventListener('submit', function (event) {
      if (submitButton.hasAttribute('disabled')) {
        event.preventDefault();
      }
    });

    if (fileList) {
      fileList.addEventListener('click', function (event) {
        if (event.target.matches('[data-contact-form-file-remove-button]')) {
          const fileItem = event.target.closest('.file-item');
          fileItem.remove();
          checkRequiredFields();
          if (fileList.querySelectorAll('.file-item').length === 0) {
            submitButton.setAttribute('disabled', 'disabled');
            errorMessage.style.display = 'block';
          }
        }
      });
    }
    checkRequiredFields();
  });
});

document.getElementById('ContactForm-phone').addEventListener('input', function (event) {
  event.target.value = event.target.value.replace(/[^0-9-]/g, '');
});